import { get, post } from "../web.request";

export const getGlobalSettings = async () => {
  return await get('/globalSettings');
};

export const startMongoSync = async () => {
  return await post('/syncMongoData', {});
};

export const getMongoSyncStatus = async () => {
  return await get('/syncMongoStatus');
};
